// extracted by mini-css-extract-plugin
export var label = "_eg-2";
export var slideContainer = "_eg-0";
export var slider = "_eg-1";